import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const consoleError = console.error.bind(console);
console.error = (...args: unknown[]): void => {
  const safeArgs = args.map(arg =>
    arg == null ? new Error('Unhandled rejection without error details.') : arg
  );
  consoleError(...safeArgs);
};

if (environment.production) {
  enableProdMode();
}
if (environment.name === 'prod') {
  const clarityScript = document.createElement('script');
  clarityScript.type = 'text/javascript';
  clarityScript.text = `(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window,document,"clarity","script","mk0shjtv0x");`;
  document.head.appendChild(clarityScript);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
